import { defaultIcons } from "@b2bportal/core-themes";
import { type ConfigTheme, fromBasicConfig } from "@hopper-b2b/portal";
import { ClientName } from "@hopper-b2b/types";
import { branding } from "../../src/modules/branding";
import { uberDarkVariables } from "../../src/modules/darkTheme";
import { uberVariables } from "../../src/modules/defaultTheme";
import { styleOverrides } from "../../src/overrides";
import { images } from "../../src/theme/images";
import {
  darkModeIconsSvg,
  lightModeIconsSvg,
} from "../components/Body/sharedIconsSvg";
import translation from "./translation";

export const corePortalConfigFromBasicConfig = (darkMode: boolean) => {
  const themeVariables = (): Pick<ConfigTheme, "variables" | "icons"> => {
    const icons = {
      ...defaultIcons,
    };

    return darkMode
      ? {
          variables: uberDarkVariables,
          icons: {
            ...icons,
            ...darkModeIconsSvg,
          },
        }
      : {
          variables: uberVariables,
          icons: {
            ...icons,
            ...lightModeIconsSvg,
          },
        };
  };

  return fromBasicConfig({
    clientName: ClientName.UBER,
    bootConfig: {},
    theme: {
      ...themeVariables(),
      styleOverrides: styleOverrides,
      images: images,
    },
    featureFlags: {},
    branding: branding,
    translations: translation,
  });
};
